export default __webpack_public_path__ + "static/media/malls.eccc377a.jpeg";